import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

/**
 * PhoneField — phone input with auto-detected country flag and dial code prefix.
 * The user only types the local number; the flag/prefix is set automatically.
 *
 * Props:
 *   value: full E.164 number (e.g. "+355694087888")
 *   onChange(value, country): callback
 *   placeholder, disabled, className, dataTestId
 */
const PhoneField = ({ value, onChange, placeholder, disabled, className = "", dataTestId }) => {
  const [country, setCountry] = useState("al"); // default fallback

  useEffect(() => {
    if (value) return; // user already typed
    let cancelled = false;
    fetch("https://ipapi.co/json/")
      .then((r) => r.json())
      .then((d) => {
        if (cancelled) return;
        if (d?.country_code) setCountry(d.country_code.toLowerCase());
      })
      .catch(() => {
        // silent fallback
      });
    return () => {
      cancelled = true;
    };
  }, [value]);

  return (
    <div className={`phone-field-wrapper ${className}`} data-testid={dataTestId || "phone-field"}>
      <PhoneInput
        country={country}
        value={value}
        onChange={(val, c) => onChange?.(val, c)}
        placeholder={placeholder || "Numri"}
        disabled={disabled}
        enableSearch
        countryCodeEditable={false}
        inputClass="!w-full !h-[46px] !pl-14 !pr-4 !rounded-lg !border-slate-200 !bg-slate-50 !text-base focus:!ring-2 focus:!ring-[#1CA3B0]/50 focus:!border-[#1CA3B0]"
        buttonClass="!rounded-l-lg !border-slate-200 !bg-slate-50 hover:!bg-slate-100"
        dropdownClass="!rounded-lg !shadow-lg"
        containerClass="!w-full"
        specialLabel=""
      />
    </div>
  );
};

export default PhoneField;
